module.exports = __webpack_public_path__ + "static/media/UNOM.a4b9a4ae.png";